import React, { useEffect, useState } from "react";
import { fetchAdminProfile } from "../../api";
import "./AdminProfile.css";

const AdminProfile = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("adminToken");
        if (!token) throw new Error("Authentication token not found.");
        const response = await fetchAdminProfile(token);
        setProfile(response.data);
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  if (!profile) {
    return <div>Loading...</div>;
  }

  return (
    <div className="profile-container">
      <h2>Admin Profile</h2>
      <p>
        <strong>Name:</strong> {profile.first_name} {profile.last_name}
      </p>
      <p>
        <strong>Email:</strong> {profile.email}
      </p>
      <p>
        <strong>Created At:</strong>{" "}
        {new Date(profile.date_created).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        })}
      </p>
    </div>
  );
};

export default AdminProfile;
